























































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { Action } from "vuex-class";

const namespace: string = "RootApp";

@Component

export default class PublicContactComponent extends Vue {
    @Action("_appAbout", { namespace }) _appAbout: any;

    items = [];

    mounted() {
        this.$services.contact.getAllContact()
            .then((resp) => {
                this.items = resp;
            });
    }
}
